import { render } from "./karban.vue?vue&type=template&id=47090b98&scoped=true"
import script from "./karban.vue?vue&type=script&lang=js"
export * from "./karban.vue?vue&type=script&lang=js"

import "./karban.vue?vue&type=style&index=0&id=47090b98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47090b98"]])

export default __exports__